export default "__VITE_ASSET__ClP8$SZ0__"